@if (active()) {
  <div>
    <ng-content />
  </div>
}
